export default "/images/paypal_me.png";